import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { SettingsMapper, SettingsErrorsMapper } from '../mappers';
import { IBranchesSettingsDto } from '../dtos';

export type IUpdateBranchesSettingsRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type IUpdateBranchesSettingsRepo = IRepo<[IBranchesSettingsDto], IUpdateBranchesSettingsRepoResponse>;

export const UpdateBranchesSettingsRepoType = Symbol.for('UpdateBranchesSettingsRepoType');

@bind(UpdateBranchesSettingsRepoType)
export class UpdateBranchesSettingsRepo implements IUpdateBranchesSettingsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: IBranchesSettingsDto) {
    try {
      const body = new FormData();
      const mappedBody = SettingsMapper.branchesDtoToPersistence(dto);
      appendToFormData(mappedBody, body);
      const url = urlMaker('/api/admin/settings/data');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = SettingsErrorsMapper.branchesError(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
